<template>
  <VBlock class="in-progress-orders" :direction="Direction.column" :sort="Sort.left_center">
    <VBlock v-for="(order, index) in inProgressOrders" :key="index">
      <VSection
        class="order-card"
        :title="order.displayStatus"
        :imageType="order.reservation && order.displayDeliveryProgress < 25 ? 2 : 1"
        :underlineWidth="order.reservation && order.displayDeliveryProgress < 25 ? 75 : 56"
        :padding="[20, 15, 0, 15]"
        :size="18"
      >
        <VBlock class="inner-wrapper" :direction="Direction.column" :sort="Sort.left_center">
          <VBlock :sort="Sort.left_center">
            <VA class="inner-contents" :onClick="() => { onOrderDetail(order.orderId) }">
              <!-- TODO 배달진행 아이콘 src/components/my/order/DeliveringItem.vue:47 -->
              <VBlock class="image-wrapper" :sort="Sort.left_top">
                <VBlock class="image">
                  <VImage class="overlay-icon" :src="resources.icon" :width="42" :height="42" />
                  <VImage
                    class="indicator-image"
                    :src="reservationImage(order.displayDeliveryProgress)"
                    :width="70"
                    :height="70"
                  />
                </VBlock>
              </VBlock>
              <VBlock class="contents-text" :direction="Direction.column" :sort="Sort.left_center">
                <!-- <VBlock
                  v-if="order.isDisplayDeliveryTitle"
                  class="contents-time"
                  :sort="Sort.left_center"
                >-->
                <VP
                  class="reservation-time-text"
                  :text="`${order.displayDeliveryTitle} • ${order.shopName}`"
                  :size="16"
                  :color="TextColor.warning"
                  :weight="TextWeight.bold"
                />
                <!-- <div class="reservation-dot"></div>
                  <VSpan
                    class="reservation-time-text"
                    :text="order.shopName"
                    :size="16"
                    :color="TextColor.warning"
                    :weight="TextWeight.bold"
                  />
                </VBlock>-->
                <VP
                  class="reservation-title"
                  :text="order.orderName"
                  :size="20"
                  :weight="TextWeight.bold"
                />

                <VP
                  class="order-name"
                  :text="`${order.paymentAmount}원`"
                  :size="16"
                  :type="TextType.Number"
                />

                <VBlock v-if="order.reservation" class="reservation-wrapper">
                  <VSpan class="reservation-text" text="예약" :size="10" :color="TextColor.gray3" />
                </VBlock>
              </VBlock>
            </VA>
          </VBlock>
          <VBlock class="order-history-button-wrapper">
            <VButton
              class="order-history-button"
              :onClick="() => { onDeliveryTracking(order.orderId) }"
              :radius="4"
            >
              <VBlock class="order-history-button-inner">
                <VBlock class="order-history-button-image-wrapper" :padding="[1, 4, 2, 0]">
                  <VImage :src="resources.deliveryStatusIcon" :width="25" :height="25" />
                </VBlock>
                <VSpan text="배달현황" :size="14" />
              </VBlock>
            </VButton>
            <VButton
              v-if="isShowChatbot(order)"
              :class="{'order-history-button': true, 'left-blank': true}"
              :onClick="() => { onChatbot(order.orderId) }"
              :radius="4"
            >
              <VBlock class="order-history-button-inner">
                <VBlock class="order-history-button-image-wrapper" :padding="[1, 4, 2, 0]">
                  <VImage :src="resources.chatbotIcon" :width="25" :height="25" />
                </VBlock>
                <VSpan text="채팅상담" :size="14" />
              </VBlock>
            </VButton>
            <VButton
              :class="{'order-history-button': true, 'left-blank': true}"
              :onClick="() => { onOrderDetail(order.orderId) }"
              :radius="4"
            >
              <VBlock class="order-history-button-inner">
                <VBlock class="order-history-button-image-wrapper" :padding="[1, 4, 2, 0]">
                  <VImage :src="resources.deliveryDetailIcon" :width="25" :height="25" />
                </VBlock>
                <VSpan text="주문상세" :size="14" />
              </VBlock>
            </VButton>
          </VBlock>
        </VBlock>
      </VSection>
    </VBlock>
  </VBlock>
</template>

<script>
import VBlock, { Direction, Sort } from '../../molecules/VBlock'
import VSpan, { TextType, TextColor, TextWeight } from '../../atoms/VSpan'
import VP from '../../atoms/VP'
import VImage from '../../atoms/VImage'
import VButton from '../../atoms/VButton'
import VSection from '../../molecules/VSection'
import VA from '../../molecules/VA'

import delivery_progress_0 from '@/assets/images/delivery-1.svg'
import delivery_progress_25 from '@/assets/images/delivery-2.svg'
import delivery_progress_50 from '@/assets/images/delivery-3.svg'
import delivery_progress_75 from '@/assets/images/delivery-4.svg'
import chatbotIcon from '@/assets/images/call-normal.svg'

import deliveryStatusIcon from '@/assets/images/delivery-status-normal.svg'
import deliveryDetailIcon from '@/assets/images/delivery-detail-normal.svg'

import icon from '@/assets/images/bmart-nor-42@2x.png'

import { isProvideChatbotOpen } from '../../../../../../config/featureProvider'

export default {
  name: 'InProgressOrders',
  components: { VA, VSection, VSpan, VBlock, VButton, VImage, VP },
  props: {
    inProgressOrders: {
      type: Array,
      required: true
    },
    onOrderDetail: {
      type: Function,
      required: true
    },
    onDeliveryTracking: {
      type: Function,
      required: true
    },
    chatbotStatus: {
      type: Object,
      required: true
    },
    onChatbot: {
      type: Function,
      required: true
    }
  },
  methods: {
    isShowChatbot(order) {
      const { appVersion, isAndroid } = this.$store.getters
      const { signed } = this.$route.query

      return (
        signed === 'true' &&
        (order.reservation ? order.displayDeliveryProgress >= 25 : true) &&
        isProvideChatbotOpen({ appVersion, isAndroid }) &&
        this.chatbotStatus.isServiceArea() &&
        this.chatbotStatus.isOperating()
      )
    },
    reservationImage(state) {
      let imageUrl = this.resources[`delivery_progress_${state}`]

      return imageUrl
    }
  },
  data() {
    return {
      Direction,
      Sort,
      TextType,
      TextColor,
      TextWeight,

      resources: {
        icon,
        delivery_progress_0,
        delivery_progress_25,
        delivery_progress_50,
        delivery_progress_75,
        deliveryStatusIcon,
        deliveryDetailIcon,
        chatbotIcon
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.in-progress-orders {
  width: 100%;
  height: auto;
  // padding-top: 10px;
  box-sizing: border-box;

  .order-card {
    width: 100%;
    height: auto;
    margin-top: 10px;
    border-bottom: 1px solid $light-gray-5;
    padding: 9px 0 0 0;
    box-sizing: border-box;

    .inner-wrapper {
      height: auto;
      padding: 20px 15px 20px 15px;
      box-sizing: border-box;

      .inner-contents {
        width: 100%;
        height: auto;
        display: flex;
        justify-content: left;
        // padding-left: 16px;
        margin-bottom: 20px;
        box-sizing: border-box;

        .image-wrapper {
          position: relative;
          width: auto;
          height: auto;
          margin-right: 15px;

          .image {
            position: relative;
            width: 70px;
            height: 70px;

            .indicator-image {
              width: auto;
              height: auto;
              min-width: 70px;
              min-height: 70px;
            }

            .overlay-icon {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              // width: 34px;
              // height: 29px;
            }
          }
        }

        .contents-text {
          width: calc(100% - 85px);
          height: auto;
          // padding-right: 10px;
          box-sizing: border-box;

          /* .text-margin {
            margin-bottom: 4px;
          } */

          /* .contents-time {
            .reservation-dot {
              width: 3px;
              height: 3px;
              background-color: $orange;
              margin-left: 6px;
              margin-right: 6px;
            } */

          .reservation-time-text {
            width: 100%;
            height: auto;
            letter-spacing: -0.4px;
            margin-bottom: 5px;
            white-space: pre-line;
            text-align: left;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }

          /* } */
          .reservation-title {
            /* letter-spacing: -0.47px; */
            white-space: pre-line;
            text-align: left;
            letter-spacing: -0.4px;
            line-height: 1.1;
            margin-bottom: 5px;
            /* word-break: break-all; */
          }

          // .order-item-wrapper {
          //   width: 100%;
          //   height: auto;
          //   flex-wrap: wrap;

          .order-name {
            width: 100%;
            // height: 100%;
            // max-height: 50px;
            /* word-break: break-all; */
            white-space: pre-line;
            text-align: left;
            // margin-right: 6px;
          }
          // }

          .reservation-wrapper {
            width: 28px;
            height: 18px;
            // padding: 5px;
            padding-top: 1px;
            background-color: $light-gray-8;
            margin-top: 4px;
            border-radius: 2px;

            .reservation-text {
              width: auto;
              height: auto;
            }
          }
        }
      }
    }
  }

  .order-history-button-wrapper {
    width: 100%;
    height: auto;
    // padding: 0 10px 0 10px;
    box-sizing: border-box;
    margin-top: 4px;

    .left-blank {
      margin-left: 6px;
    }

    .order-history-button {
      width: 100%;
      height: 50px;
      padding: 0;
      box-sizing: border-box;
      /* border-collapse: collapse; */
      border: 1px solid $light-gray-4;

      .order-history-button-inner {
        .order-history-button-image-wrapper {
          width: auto;
        }
      }

      // &:first-child {
      //   margin-right: 6px;
      /* border-top-left-radius: 4px !important;
        border-bottom-left-radius: 4px !important; */
      // }

      // &:last-child {
      //   margin-left: 6px;
      /* margin-left: -1px;
        border-top-right-radius: 4px !important;
        border-bottom-right-radius: 4px !important; */
      // }
    }
  }
}
</style>
